import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SearchBar } from "@features/search/ui/SearchBar";
import { NAVIGATION_ITEMS } from "@shared/config/navigation";
import { HashLink } from 'react-router-hash-link';

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const scrollWithOffset = (el: HTMLElement) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80; // Здесь можно настроить смещение (например, высота фиксированного хедера)
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' });
  };

  return (
    <header className="flex justify-between items-center py-5 mx-auto my-0 w-full text-xl font-bold container md:mt-[40px] relative">
      {/* Логотип */}
      <Link to="/" className="flex items-center gap-3 w-fit">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/d1539f68f51c7c8931b55d7cc7400f95ee2926a1901e97c21a8bd733ecce5b7d?apiKey=e11f1c3e4c454432a22c0ca424050c32&"
          alt="Company Logo"
          className="object-contain h-11 w-[147px] sm:w-[150px]"
        />
      </Link>

      {/* Бургер-кнопка для мобильных устройств */}
      <button
        className="sm:hidden p-2 focus:outline-none"
        onClick={toggleMenu}
        aria-label="Toggle menu"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          width="24"
          height="24"
          fill="currentColor"
        >
          {menuOpen ? (
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
          ) : (
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
          )}
        </svg>
      </button>

      {/* Навигация для десктопов */}
      <nav className="hidden sm:flex flex-wrap justify-center gap-4 md:gap-6 items-center mb-4 md:mb-0">
            <HashLink className="text-[21px] cursor-pointer font-bold hover:text-yellow-400" smooth to="/#about-huter" scroll={el => scrollWithOffset(el)}>
              About us
            </HashLink>
        {NAVIGATION_ITEMS.map((item) => (
          <Link
            key={item.id}
            to={item.path}
            className="text-[21px] cursor-pointer font-bold hover:text-yellow-400"
          >
            {item.label}
          </Link>
        ))}
        <HashLink className="text-[21px] cursor-pointer font-bold hover:text-yellow-400" smooth to="/#contacts" scroll={el => scrollWithOffset(el)}>
              Contacts
            </HashLink>
      </nav>

      {/* Поисковая строка */}
      <div className="hidden sm:flex flex-col items-end">
        <SearchBar className="w-[220px]" />
      </div>

      {/* Мобильное меню */}
      {menuOpen && (
        <div className="sm:hidden fixed inset-0 bg-black bg-opacity-50 z-50" onClick={toggleMenu}>
          <div className="absolute top-0 right-0 h-full w-3/4 bg-white p-4 shadow-lg">
            <nav className="flex flex-col gap-4">
            <HashLink smooth to="/#about-us" scroll={el => scrollWithOffset(el)}>
              About us
            </HashLink>
              {NAVIGATION_ITEMS.map((item) => (
                <Link
                  key={item.id}
                  to={item.path}
                  className="text-[21px] cursor-pointer font-bold hover:text-yellow-400"
                  onClick={toggleMenu}
                >
                  {item.label}
                </Link>
              ))}
              <HashLink smooth to="/#contacts" scroll={el => scrollWithOffset(el)}>
              Contacts
            </HashLink>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;